<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-window-restore"></i> {{ "TITLE.ADD-INSTALLER" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="installerForm">
      <div class="form-row">
        <div class="col">
          <label for="OperatingSystem"><b>{{ "LABEL.OPERATING-SYSTEM" | translate }}</b></label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fab fa-windows"></i></div>
            </div>
            <select class="form-control"
                    id="operatingSystem"
                    [attr.disabled]="disableOnEditOnInstallers ? '' : null"
                    formControlName="operatingSystem"
                    [(ngModel)]="moreAboutInstaller.operatingsystemId"
                    (ngModelChange)="reloadInstaller()"
                    [class.is-invalid]="isInvalidControl('operatingSystem')">
              <option *ngFor="let operatingsystem of operatingsystems"
                      [ngValue]="operatingsystem.id">{{operatingsystem.description | translate}}</option>
            </select>
          </div>
        </div>
        <div class="col">
          <label for="OperatingSystem"><b>{{ "LABEL.FILE-TYPE" | translate }}:</b></label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fas fa-file"></i></div>
            </div>
            <select class="form-control"
                    id="typeFile"
                    [attr.disabled]="disableOnEditOnInstallers ? '' : null"
                    formControlName="typeFile"
                    [(ngModel)]="moreAboutInstaller.typefile"
                    (ngModelChange)="reloadInstaller()"
                    [class.is-invalid]="isInvalidControl('typeFile')">
              <option *ngFor="let typeFile of typefiles"
                      [ngValue]="typeFile.id">{{typeFile.description | translate}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="type"><b>{{ "LABEL.APPLICATION-TYPE" | translate }}</b></label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fab fa-app-store"></i></div>
          </div>
          <select class="form-control"
                  id="type"
                  [attr.disabled]="disableOnEditOnInstallers ? '' : null"
                  formControlName="type"
                  [(ngModel)]="moreAboutInstaller.typeApp"
                  (ngModelChange)="reloadInstaller()"
                  [class.is-invalid]="isInvalidControl('type')">
            <option *ngFor="let signatureAppType of signatureapptypes"
                    [ngValue]="signatureAppType.id">{{signatureAppType.shortdescription | translate}}</option>
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="col" [hidden]="disableOnEditOnInstallers">
          <label for="version"><b>{{ "LABEL.CURRENT-VERSION" | translate }}</b></label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fas fa-minus"></i></div>
            </div>
            <input type="text"
                   id="currentVersion"
                   [attr.disabled]="!disableOnEditOnInstallers ? '' : null"
                   class="form-control"
                   formControlName="currectVersion"
                   [(ngModel)]="currentVersion">
          </div>
        </div>
        <div class="col">
          <label for="version"><b>{{ "LABEL.VERSION" | translate }}</b></label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fas fa-plus"></i></div>
            </div>
            <input type="text"
                   id="version"
                   [attr.disabled]="disableOnEditOnInstallers ? '' : null"
                   class="form-control"
                   placeholder="{{ 'MESSAGE.ENTER-THE-VERSION' | translate }}"
                   [(ngModel)]="installer.version"
                   formControlName="version"
                   [class.is-invalid]="isNewInstaller ? isInvalidControlForVersion('version') : isInvalidControl('version')">
          </div>
          <small *ngIf="isNewInstaller ? isInvalidControlForVersion('version') : false"
                 class="text-danger">
            {{ getErrorMessageBy('version')}}
          </small>
        </div>
      </div>
      <div class="form-group" [hidden]="disableOnEditOnInstallers">
        <label for="appFile"><b>{{ "LABEL.FILE" | translate }}</b></label>
        <div class="padding-select-file">
          <div class="custom-file content-file">
            <input type="file" class="custom-file-input w-100 content-file"
                   accept="{{isInstaller() ? '.exe, .pkg' : '.zip, .rar'}} "
                   id="appFile" (change)="changeStatus($event)"
                   [class.is-invalid]="isInvalidControl('appFilename2Show')">
            <small *ngIf="isInvalidControl('appFilename2Show')"
                   class="text-danger">
              {{ "MESSAGE.SELECT-FILE" | translate }}
            </small>
            <label class="custom-file-label"
                   for="appFile">
              {{installerForm.get('appFilename2Show').value ? installerForm.get('appFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
            </label>
          </div>
        </div>
      </div>
      <div class="form-group" [hidden]="disableOnEditOnInstallers">
        <label><small>{{ "LABEL.FILE-UPLOAD-PROGRESS" | translate }}</small></label>
        <div class="progress form-group mt-2">
          <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
               [style.width.%]="progressUpdate">
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="description"><b>{{ "LABEL.DESCRIPTION" | translate }}</b></label>
        <textarea type="text"
                  id="description"
                  class="form-control"
                  [(ngModel)]="installer.description" [rows]="4"
                  formControlName="description"
                  [class.is-invalid]="isInvalidControl('description')">
                  </textarea>
        <small *ngIf="isInvalidControl('description')"
               class="text-danger">
          {{ "MESSAGE.ENTER-DESCRIPTION" | translate }}
        </small>
      </div>
      <div class="form-group">
        <label for="description"><b>{{ "LABEL.UPDATED-VERSION-MESSAGE" | translate }}</b></label>
        <textarea type="text"
                  id="updatedVersionMessage"
                  class="form-control"
                  [(ngModel)]="moreAboutInstaller.updatedVersionMessage" [rows]="4"
                  formControlName="updatedVersionMessage"
                  [class.is-invalid]="isInvalidControl('updatedVersionMessage')">
                  </textarea>
        <small *ngIf="isInvalidControl('updatedVersionMessage')"
               class="text-danger">
          {{ "MESSAGE.ENTER-UPDATE-VERSION-MESSAGE" | translate }}
        </small>
      </div>
      <div class="form-group">
        <label for="description"><b>{{ "LABEL.NEW-VERSION-MESSAGE" | translate }}</b></label>
        <textarea type="text"
                  id="newVersionMessage"
                  class="form-control"
                  [(ngModel)]="moreAboutInstaller.newVersionMessage" [rows]="4"
                  formControlName="newVersionMessage"
                  [class.is-invalid]="isInvalidControl('newVersionMessage')">
                  </textarea>
        <small *ngIf="isInvalidControl('newVersionMessage')"
               class="text-danger">
          {{ "MESSAGE.ENTER-NEW-VERSION-MESSAGE" | translate }}
        </small>
      </div>
      <div class="row">
        <div class="col" *ngIf="!isNewInstaller">
          <label for="state" class="col-form-label">{{ "LABEL.STATE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="{{isActive ? 'input-group-text': 'input-group-text-danger' }}">
                <i class="{{isActive ? 'fas fa-toggle-on': 'fas fa-toggle-off' }}"></i></div>
            </div>
            <select class="form-control"
                    id="state"
                    formControlName="status"
                    [(ngModel)]="installer.active"
                    [class.is-invalid]="isInvalidControl('status')">
              <option [value]="true">{{ "LABEL.ACTIVE" | translate }}</option>
              <option [value]="false">{{ "LABEL.INACTIVE" | translate }}</option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i>  {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>

<app-loading *ngIf="loading"></app-loading>
